import { tagAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import textStyles from "../../../../theme/foundations/generated/textStyles";
import { getTagHeight } from "../helper";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["leftIcon", "text", ...parts.keys]);
const baseStyle = definePartsStyle(({ ellipsis, maxWidth, isReadOnly }) => ({
    container: {
        borderRadius: "none",
        flexShrink: 0,
    },
    leftIcon: {
        pr: "2",
    },
    text: Object.assign(Object.assign({}, (isReadOnly ? textStyles.body.medium : textStyles.body.mediumBold)), { whiteSpace: ellipsis ? "nowrap" : "", overflow: ellipsis ? "hidden" : "", textOverflow: ellipsis ? "ellipsis" : "", maxWidth }),
}));
const sizes = {
    lg: definePartsStyle(({ size }) => ({
        container: {
            height: getTagHeight(size),
            px: "3",
        },
    })),
    md: definePartsStyle(({ size }) => ({
        container: {
            height: getTagHeight(size),
            px: "2",
        },
    })),
    sm: definePartsStyle(({ size }) => ({
        container: {
            height: getTagHeight(size),
            px: "2",
        },
    })),
};
const variants = {
    select: definePartsStyle({
        container: {
            background: "semantic.tag.defaultEnable",
            color: "semantic.text.primary",
            _hover: {
                background: "semantic.tag.defaultHover",
                color: "semantic.text.inverse",
                boxShadow: "large !important",
                ".tag-left-icon": {
                    color: "semantic.icon.inverse",
                },
            },
            _active: {
                background: "semantic.cta.secondaryPressed",
                color: "semantic.text.inverse",
                boxShadow: "medium !important",
                ".tag-left-icon": {
                    color: "semantic.icon.inverse",
                },
            },
            _focusVisible: {
                boxShadow: "none",
                background: "semantic.tag.defaultEnable",
                color: "semantic.text.primary",
                outline: "3px solid",
                outlineColor: "semantic.outline.focus",
            },
        },
        leftIcon: {
            color: "semantic.interactive.primary",
        },
    }),
    default: definePartsStyle(({ customColor }) => ({
        container: {
            background: customColor || "semantic.tag.defaultEnable",
            color: "color.text.primary",
            _hover: {},
            _active: {},
            _focusVisible: {},
        },
        leftIcon: {
            color: "semantic.interactive.primary",
        },
    })),
    selected: definePartsStyle({
        container: {
            background: "semantic.tag.validationEnable",
            color: "semantic.text.success",
            _hover: {
                background: "semantic.tag.validationHover",
                color: "semantic.text.inverse",
                boxShadow: "large !important",
                ".tag-left-icon": {
                    color: "semantic.icon.inverse",
                },
            },
            _active: {
                background: "semantic.cta.secondaryPressed",
                color: "semantic.text.inverse",
                boxShadow: "medium !important",
                ".tag-left-icon": {
                    color: "semantic.icon.inverse",
                },
            },
        },
        leftIcon: {
            color: "semantic.icon.success",
        },
    }),
};
const TagTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    sizes,
    defaultProps: {
        size: "lg",
        variant: "default",
    },
});
export default TagTheme;
//# sourceMappingURL=Tag.default.js.map